// deps
import { createContext } from "react";

export interface IPinVerificationCardData {
    title: string;
    description: string;
    hostName?: string;
}

export interface ITableContext {
    tableId?: string;
    restaurantId?: string;
    parentOrderId?: string;
    verifyPinFlow?: boolean;
    setVerifyPinFlow?: (value: boolean) => void;
    updateParentOrderId?: (parentOrderId: string) => void;
    // Action re-executed after pin verification succeeds (re-call place order / re-fetch orders).
    // May return a promise so the pin card can keep its loader until the re-call resolves.
    pendingVerifyCallback?: (() => void | Promise<unknown>) | null;
    setPendingVerifyCallback?: (cb: (() => void | Promise<unknown>) | null) => void;
    // Title/description shown on the centrally rendered PinVerificationCard.
    pinVerificationCardData?: IPinVerificationCardData | null;
    setPinVerificationCardData?: (data: IPinVerificationCardData | null) => void;
}

export default createContext<ITableContext>({
    tableId: undefined,
    restaurantId: undefined,
    parentOrderId: "",
    verifyPinFlow: false,
    setVerifyPinFlow: () => {},
    updateParentOrderId: () => {},
    pendingVerifyCallback: null,
    setPendingVerifyCallback: () => {},
    pinVerificationCardData: null,
    setPinVerificationCardData: () => {},
});
